<template>
    <div>
        <loading-component :value="loading"></loading-component>
        <v-card>
            <v-card>
                <v-card-title>
                    <v-layout row wrap>
                        <v-flex xs6>
                            <h1>Captain Balance</h1>
                        </v-flex>
                        <v-flex xs6 style="padding:8px">
                            <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Search"
                                    single-line
                                    hide-details
                                    @keyup.enter="getData"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-data-table :url="url"
                              :headers="headers"
                              :items="data"
                              :pagination.sync="pagination"
                              :total-items="totalItems"
                              :rows-per-page-items="[5, 10, 15, 25, 100]"
                              :loading="loading">
                    <template v-slot:items="props">
                        <tr>
                            <td class="text-xs-center">{{ props.item.id }}</td>
                            <td class="text-xs-center">{{ props.item.captain_name }}</td>
                            <td class="text-xs-center"
                                :style="{color: props.item.overall_closing <= 0 ? 'green' : 'red'}">
                                {{props.item.overall_closing }}
                            </td>
                            <td class="text-xs-center"
                                :style="{color: props.item.overall_closing_checker <= 0 ? 'green' : 'red'}">
                                {{ props.item.overall_closing_checker }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-card>
    </div>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        name: "CaptainBalance",
        components: {DataTable, LoadingComponent},
        title: 'Captain Balance',
        data() {
            return {
                headers: [
                    {text: 'ID', value: 'id', align: 'center'},
                    {text: 'Captain', value: 'captain_name', align: 'center'},
                    {text: 'All', value: 'overall_closing', align: 'center'},
                    {text: 'O.All', value: 'overall_closing_checker', sortable: false, align: 'center'},
                ],
                data: [],
                loading: false,
                search: '',
                totalItems: 0,
                pagination: {
                    rowsPerPage: 10
                },
                url: 'payment/captain_balance'
            }
        },
        mounted() {
            this.getData();
        },
        watch: {
            pagination: {
                handler() {
                    this.getData();
                },
                deep: true
            }
        },
        methods: {
            getData() {
                this.loading = true;
                const params = new URLSearchParams();
                params.append('page', this.pagination.page);
                params.append("perPage", String(this.pagination.rowsPerPage));
                params.append("sortBy", String(this.pagination.sortBy));
                params.append("descending", String(this.pagination.descending));
                params.append("search", String(this.search));
                params.append("status", String(this.payment_status));
                this.axios.get(this.url, {params})
                    .then(res => {
                        this.data = res.data.data.data;
                        this.totalItems = res.data.data.total;
                        this.pagination.rowsPerPage = Number(res.data.data.per_page);
                        this.loading = false;
                    }).catch(err => {
                    console.log(err.message);
                    this.loading = false;
                });
            },
        }
    }
</script>

<style scoped>

</style>